import React from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'; // Import BrowserRouter and Link

const TrainingTopics = () => {
    // Data for training programs, structured similarly to CommunityPriceUpdate's 'codes'
    const trainingPrograms = {
        'Audit Your Life, Business & Income': {
            fullTitle: "Audit Your Life, Business & Income (Entrepreneurs, Business Owners, CEO's, Executive, Professional, Students, any Go getters)",
            subtitle: "Break Through Plateaus & Build a Million-Dollar Gameplan",
            duration: "Day Long",
            regularPrice: "10,000 BDT",
            offerPrice: "Free/6000",
            format: "Offline/ Online",
            outcomes: [
                'Identify income leaks & business gaps',
                'Create a personal business roadmap',
                'Learn action-first mindset to fix, grow & scale',
            ],
            // Use a specific price for the Purchase Now link, defaulting to regular if offer is "Free"
            // You might adjust this logic based on how "Free" programs are handled in your order system
            purchaseAmount: '6000', // Assuming 10,000 for order link even if offer is free for display
        },
        'Launch Code': {
            fullTitle: "Launch Code for Entrepreneurs & Startup & Business Owners",
            subtitle: "Start & Launch a Scalable Digital Business with Confidence",
            duration: "2 Days",
            regularPrice: "2,30,000 BDT",
            offerPrice: "75,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Launch your digital business within 21–30 days using our plug-and-play model.',
                'Create your first sales page or offer a funnel to collect payments instantly.',
                'Identify your niche + ideal audience in 30 minutes with our TMI Formula.',
                'Create a 3-month content + lead strategy that brings in 10–50 clients.',
                'Discover how to raise 50K–10L+ BDT in capital from non-bank sources.',
                'Learn how to read market trends to stay ahead 12–24 months.',
                'Design your profitable product ladder (free to high-ticket) in one day.',
                'Write your brand story and core messaging that increases trust by 10X',
                'Learn business documentation for fundraising, scaling, or partnership deals.',
                'Understand your profit roadmap with breakeven analysis within 1 hour.',
            ],
            purchaseAmount: '75000',
        },
        'Growth Code': {
            fullTitle: "Growth Code for Entrepreneurs & Business Owners",
            subtitle: "Build a High-Converting Business with Smart Sales, Marketing & Branding",
            duration: "2 Days",
            regularPrice: "3,00,000 BDT",
            offerPrice: "1,50,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Build your complete sales system with funnel to generate 20–100+ daily leads.',
                'Increase sales conversions by 30–70% with our Sales Language Scripts.',
                'Clarify your brand message to grow your online visibility by 5X.',
                'Build your Customer Journey Funnel to track and optimize ROI Monthly, Weekly even Daily.',
                'Launch your first high-converting ad campaign with COI (Cost of Inaction) metrics.',
                'Learn how to hire 1–7 productive employees with Zero HR background.',
                'Set your 6-month Marketing Calendar with weekly KPI reviews.',
                'Create 5 pieces of evergreen content that generate sales every week.',
                'Increase client lifetime value (LTV) by 2–3X with upsell systems.',
                'Learn how to balance Paid Ads vs Organic Funnels to reduce ad cost by 30%.',
            ],
            purchaseAmount: '150000',
        },
        'Scale Code': {
            fullTitle: "Scale Code for Entrepreneurs & Business Owners",
            subtitle: "Systemize, Structure, Automate and Scale Your Business to the Next Level",
            duration: "2 Days",
            regularPrice: "5,00,000 BDT",
            offerPrice: "2,50,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Build 5+ core systems to automate 70% of your operations.',
                'Develop a leadership structure with 6–12 key players in 90 days.',
                'Implement SOPs to reduce team dependency on you by 50%.',
                'Grow revenue 2X–5X by applying scalable funnels & retention models.',
                'Understand structure vs system vs strategy and align all',
                'Learn how to raise a performance-based team with KPI.',
            ],
            purchaseAmount: '250000',
        },
        'Wealth Code': {
            fullTitle: "Wealth Code for Entrepreneurs, Business owners,CEO's, Executives, Professional, Students",
            subtitle: "Master Your Money Game and Step Into Financial Freedom",
            duration: "2 Days",
            regularPrice: "1,00,000 BDT",
            offerPrice: "25,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Master a 12-month wealth-building roadmap with monthly/weekly progress targets.',
                'Build 2–3 automated income streams within 90 days.',
                'Understand and apply the “Money Doubling Game” to 2X savings in 6 months.',
                'Learn 10+ millionaire mindsets and strategies to be millionare (dollar value) in 3 to 5 years.',
                'Build your first investment plan (even starting from 0 income).',
                'Apply AVH Business Pulse Formula to increase clarity in business cash flow 2X to 10X even 100X.',
                'Use the Language of Wealth to improve your financial decision-making by 50%.',
                'Shift from debt cycle to wealth cycle using Debt-to-Wealth Blueprint in 30 days.',
            ],
            purchaseAmount: '25000',
        },
        'Sales Code': {
            fullTitle: "Sales Code for Entrepreneurs, Business owners, Professional",
            subtitle: "Unlock High-Income Skills to Multiply Your Revenue",
            duration: "2-3 Days",
            regularPrice: "1,80,000 BDT",
            offerPrice: "60,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Build a sales process that increases closing rate by 30–50% in 60 days',
                'Master scripts and objection handling that work across any industry',
                'Convert cold leads into paying customers using the 3S Formula',
                'Design your own Sales Funnel to attract, nurture, and close clients',
                'Gain confidence to sell high-ticket products and services',
                'Track and improve your revenue using actionable metrics',
                'Train your sales team with duplicable frameworks',
                'Shift from chasing clients to having clients chase you',
            ],
            purchaseAmount: '60000',
        },
        'Digital Code': {
            fullTitle: "Digital Code for Entrepreneurs, wantrapreneurs, Business Owners",
            subtitle: "Launch, Grow & Scale Your Digital Business to Global Heights",
            duration: "2 Days",
            regularPrice: "2,00,000 BDT",
            offerPrice: "65,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Launch a digital business or offer within 30–60 days',
                'Build your online system (website/funnel/email) with no tech overwhelm',
                'Attract clients using organic + paid digital marketing methods',
                'Start earning in USD or global currencies within 90 days',
                'Build systems to automate client delivery & marketing',
                'Go from unknown to trusted expert with content + community',
                'Reach global markets even from a small town',
                'Learn a plug-and-play method to grow to 7 figures with lean team',
            ],
            purchaseAmount: '65000',
        },
        'Investment Code': {
            fullTitle: "Investment Code for Entrepreneurs, Business Owners, Professional",
            subtitle: "Smart Strategies to Grow and Multiply Wealth Like the Top 1%",
            duration: "2 Days",
            regularPrice: "2,50,000 BDT",
            offerPrice: "50,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Create a multi-sector investment plan with 3–5 sources of income.',
                'Understand the basics of stock trading and how to start with minimal risk.',
                'Discover the fundamentals of halal investing and filter 10+ options.',
                'Plan for 20–35% tax savings legally via structure & strategies.',
                'Build a personal wealth map covering real estate, equity, and more.',
                'Learn the 10 types of income and set goals to activate 3 in 6 months.',
                'Set up your first private equity, trust, or inheritance plan.',
                'Build a funding strategy using capital raising methods.',
                'Understand how to pass wealth intergenerationally with succession planning.',
                'Learn risk profiling and how to match investments to your lifestyle goals',
            ],
            purchaseAmount: '50000',
        },
        'Career Code': {
            fullTitle: "Career Code for Students, Freshers & Unemployed individual",
            subtitle: "Design a Winning Career or Start Your Own Income Path",
            duration: "2 Days",
            regularPrice: "50,000 BDT",
            offerPrice: "15,000 BDT",
            format: "Offline + Online",
            outcomes: [
                'Design your 90-day Career & Income Roadmap with milestones.',
                'Identify your top 3 money-making ways and turn one onto income in 30 days.',
                'Apply the 7-Step Dream Job Formula to get interviews in 15–30 days.',
                'Build a winning CV, pitch, and offer email for job or freelance income.',
                'Learn how to become self-employed without quitting your current role.',
                'Raise your personal income standard by 2X to 10X in 6 months with HRCM Strategy.',
                'Find your passion and turn it into a scalable business within 90 days.',
                'Set your life purpose + 5-year wealth vision.',
                'Learn the top 5 global hiring trends and how to stay ahead of AI automation.',
            ],
            purchaseAmount: '15000',
        },
    };

    // Styling properties copied from CommunityPriceUpdate
        const boxStyle = {
        width: '100%',
        maxWidth: '400px',
        padding: '20px',
        border: '1px solid violet',
        backgroundColor: 'rgba(238, 130, 238, 0.1)',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
    };

    const purchaseButtonStyle = {
        display: 'inline-block',
        marginTop: '20px',
        padding: '10px 20px',
        backgroundColor: 'purple',
        color: 'white',
        borderRadius: '6px',
        textDecoration: 'none',
        fontSize: '16px',
        textAlign: 'center',
        border: 'none', // Ensure no default border from Bootstrap Button
    };

    // Helper function to extract only the numeric part for the `amount` query parameter
    const extractAmount = (priceStr) => {
        // Remove currency symbols, "BDT", "VAT", commas, and spaces, then parse as float
        const numericStr = priceStr.replace(/[^\d.]/g, '');
        return parseFloat(numericStr) || 0; // Return 0 if parsing fails
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
            {Object.entries(trainingPrograms).map(([programTitle, program]) => (
                <div key={programTitle} style={boxStyle}>
                    <div>
                        {/* Title matching CommunityPriceUpdate h3 style */}
                        <h4 style={{ color: 'white', marginBottom: '10px' }} className='text-center'>{program.fullTitle}</h4>
                        {/* Subtitle / Tagline */}
                        <h5 style={{ marginTop: '15px', marginBottom: '15px' }} className='text-center '>{program.subtitle}</h5> {/* Changed color for dark mode */}

                        {/* Basic Info (Duration, Price, Format) */}
                        <div style={{ textAlign: 'left', marginBottom: '20px', color: '#f8f9fa' }}> {/* Changed color for dark mode */}
                            <p style={{ marginBottom: '5px' }}><strong>Duration:</strong> {program.duration}</p>
                            <p style={{ marginBottom: '5px' }}><strong>Regular Price:</strong> {program.regularPrice}</p>
                            <p style={{ marginBottom: '5px' }}><strong>Offer Price:</strong> <span style={{ color: 'lightgreen', fontWeight: 'bold' }}>{program.offerPrice}</span></p> {/* Changed color for dark mode */}
                            <p style={{ marginBottom: '0' }}><strong>Format:</strong> {program.format}</p>
                        </div>
                    </div>

                    {/* Outcomes Section */}
                    <div style={{ marginTop: 'auto' }}>
                        <h4 style={{ color: 'white', marginBottom: '10px' }}>Outcomes:</h4>
                        <ul style={{ paddingLeft: '20px', listStyleType: 'square', color: '#f8f9fa' }}> 
    {program.outcomes.map((outcome, idx) => (
        <li key={idx} style={{ marginBottom: '8px', display: 'list-item' }}>
            {outcome}
        </li>
    ))}
</ul>

                    </div>

                    {/* Pricing and Button at the bottom, matching CommunityPriceUpdate structure */}
                    <div style={{ marginTop: 'auto' }} className="text-center">
                        <h4 style={{ margin: '20px 0 10px 0', color: 'purple' }}>
                             {/* Display final price here if needed, or remove if offerPrice is sufficient */}
                        </h4>
                        <div className="text-center">
                            <Link
                                className="btn-default"
                                to={`/order?service=Training&package=${encodeURIComponent(programTitle)}&amount=${extractAmount(program.offerPrice)}`}
                            >
                                Purchase Now
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};



export default TrainingTopics;
